import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SeleccionInformesScreen from './screen';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';
import { ValidacionesAdapter } from '../../../../../../infraestructure/persistence/rest/ValidacionesAdapter';

import { downloadFile } from '../../../../../../shared/utils/download';

export const ValidacionesContainer = () => {

	const api = new ValidacionesAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	
	let [ data, setData ] = useState<any>([]);
	let [ dataDetalle, setDataDetalle ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState<boolean>(false);
	let [ dataTextPopUp, setdataTextPopUp] = useState<any>('');

	let result: any;

	const filtrarValidaciones = async (data: any) => {
		setIsLoading(true);
		try {
			result = await api.ListarValidaciones(data);
			if(result.data && result.data!=="")
			{
				setData(result.data);
				setDataDetalle([]);
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		setIsLoading(false);
  	};

	const filtrarDetalleValidaciones = async (data: any) => {
		// setIsLoading(true);
		try {
			result = await api.ListarValidaciones(data);
			if(result.data && result.data!=="")
			{
				return result.data;
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		// setIsLoading(false);
  	};

	const onValidar = async (data: any) =>{
		// alert('onValidar');
		setIsLoading(true);
		try {
			result = await api.ValidarInvalidar(data);
			if(result.data && result.data!=="")
			{
				// filtrarValidaciones(data);
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		var vReq = {IdTipo: data.IdTipo};
		filtrarValidaciones(vReq);
		// setIsLoading(false);
	};
	
	const onComprobarValidar = async (data: any) =>{
		// alert('onValidar');
		setIsLoading(true);
		setdataTextPopUp('');
		try {
			result = await api.ComprobarValidarInvalidar(data);
			if(result.data && result.data!=="")
			{
				if(result.data.length > 0){
					
					var text = "<br/>" + result.data.map((item: any)=> { return '- ' + item; }).join("<br/>") + "<br/>";
					
					setdataTextPopUp(text);
				}else{
					onValidar(data);
				}
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		var vReq = {IdTipo: data.IdTipo};
		// setIsLoading(false);
	};

	// const filtrarDetalleImportacion = async (data: any) => {
	// 	try {
	// 		result = await api.ListarDetalle(data);
	// 		if(result.data && result.data!=="")
	// 		{
	// 			console.log('filtrarDetalleImportacion ', result.data)
	// 			return result.data;
	// 		}else{resultError(); return [];}
	// 	} catch (e) {
	// 		let exception = ServerErrorMessage(e);
	// 		exceptionError(exception)
	// 		return [];
	// 	}
  	// };

	return (
		<>
			<SeleccionInformesScreen data={data} dataDetalle={dataDetalle} onFilter={filtrarValidaciones} onValidar={onValidar} onDetalleFilter={filtrarDetalleValidaciones} isLoading={isLoading} textoValidacion={dataTextPopUp} onComprobarValidar={onComprobarValidar} />
		</>
	);
};

export default ValidacionesContainer;